import { useEffect, useState } from "react";
import AppShell from "@/components/AppShell";
import api from "@/lib/api";
import { Lightbulb } from "lucide-react";

export default function Tips() {
  const [tips, setTips] = useState([]);
  useEffect(() => { api.get("/tips").then(r => setTips(r.data)); }, []);
  return (
    <AppShell>
      <div data-testid="tips-page">
        <div className="font-mono-jp text-[10px] uppercase tracking-widest text-[#d7ff00]">COACH TIPS</div>
        <h1 className="font-display text-4xl sm:text-5xl uppercase">Daily <span className="text-[#d7ff00]">insights</span></h1>

        <div className="mt-6 grid sm:grid-cols-2 gap-4">
          {tips.map(t => (
            <div key={t.id} className="bg-[#0a0a0a] border border-[#1f1f1f] border-l-4 border-l-[#d7ff00] p-5" data-testid={`tip-${t.id}`}>
              <div className="font-mono-jp text-[10px] uppercase tracking-widest text-[#d7ff00] flex items-center gap-2"><Lightbulb className="w-3 h-3" /> {t.category?.toUpperCase()}</div>
              <div className="mt-2 font-display text-2xl uppercase">{t.title}</div>
              <p className="mt-2 text-[#bbb] text-sm leading-relaxed">{t.body}</p>
            </div>
          ))}
        </div>
      </div>
    </AppShell>
  );
}
